export interface CreatePledgeFormState {
    validatingAccountAddress: boolean;
    AccountAddressValidated: boolean;
    AccountAddressError: string | undefined;
    AccountAddressDetails: AccountAddressDetails;
}

export interface AccountAddressDetails {
    AccountName: string;
    FirmName: string;
    AccountId: string;
    Account: string;
    FirmId: string;
}

export const DEFAULT_INITIAL_STATE: CreatePledgeFormState = {
    validatingAccountAddress: false,
    AccountAddressValidated: false,
    AccountAddressError: undefined,
    AccountAddressDetails: {
        AccountName: '',
        FirmName: '',
        AccountId: '',
        Account: '',
        FirmId: ''
    }
};

export type CreatePledgeFormAction =
    { type: 'ACCOUNT_CHANGED' } |
    { type: 'VALIDATING_ACCOUNT' } |
    { type: 'RESET_ACCOUNT_DETAILS' } |
    {
        type: 'SERVER_SUCCESS';
        payload: { AccountAddressDetails: AccountAddressDetails };
    } |
    {
        type: 'SERVER_ERROR';
        payload: { error: string };
    };

export const CreatePledgeFormReducer = (
    state: CreatePledgeFormState,
    action: CreatePledgeFormAction
): CreatePledgeFormState => {
    switch (action.type) {
        case 'ACCOUNT_CHANGED':
            return {
                ...state,
                validatingAccountAddress: false,
                AccountAddressValidated: false,
                AccountAddressError: undefined,
                AccountAddressDetails: DEFAULT_INITIAL_STATE.AccountAddressDetails
            };
        case 'RESET_ACCOUNT_DETAILS':
            return {
                ...state,
                AccountAddressDetails: DEFAULT_INITIAL_STATE.AccountAddressDetails
            };
        case 'VALIDATING_ACCOUNT':
            return {
                ...state,
                validatingAccountAddress: true
            };
        case 'SERVER_SUCCESS':
            return {
                ...state,
                validatingAccountAddress: false,
                AccountAddressValidated: true,
                AccountAddressError: undefined,
                AccountAddressDetails: action.payload.AccountAddressDetails
            };
        case 'SERVER_ERROR':
            return {
                ...state,
                validatingAccountAddress: false,
                AccountAddressValidated: true,
                AccountAddressError: action.payload.error,
                AccountAddressDetails: DEFAULT_INITIAL_STATE.AccountAddressDetails
            };
        default:
            return state;
    }
};